var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lunbo"},[(_vm.adList.length>0)?_c('van-swipe',{attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.adList),function(item){return _c('van-swipe-item',[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":item.adImgUrl}})])}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }